module.exports = __webpack_public_path__ + "img/stackslash-103.5b061d1c.jpg";